export enum CTAType {
  CARD = 'card',
  FORM = 'form',
}
